import { useState } from 'react';
import { Field, useFormikContext } from 'formik';

const ContactMatter = () => {
    const { values, setFieldValue } = useFormikContext();

    return (
        <>
            <div className='flex items-center my-5'>
                <span className='w-1/2 h-0.5 border border-dashed inline-block'></span>
                <p className='text-sm shrink-0 w-fit px-4'>Contact/Matter & Company</p>
                <span className='w-1/2 h-0.5 border border-dashed inline-block'></span>
            </div>
            <div className='flex items-start lg:flex-nowrap flex-wrap gap-5'>
                <div className='lg:w-1/2 w-full'>
                    <div className="space-y-5">
                        <div className='flex items-center'>
                            <span className='w-12 h-0.5 bg-border inline-block mr-2'></span>
                            <p className='text-sm'>Contact Information</p>
                        </div>
                        <Field name="invoice_template_settings.contact_info.address">
                            {({ field, form }) => (
                                <label className="switch w-1/2 justify-between">
                                    <span className="switch-label">Show Contact Address</span>
                                    <input
                                        type="checkbox"
                                        checked={field.value}
                                        onChange={() => setFieldValue("invoice_template_settings.contact_info.address", !field.value)}
                                    />
                                </label>
                            )}
                        </Field>
                        <Field name="invoice_template_settings.contact_info.email">
                            {({ field, form }) => (
                                <label className="switch w-1/2 justify-between">
                                    <span className="switch-label">Show Contact Email</span>
                                    <input
                                        type="checkbox"
                                        checked={field.value}
                                        onChange={() => setFieldValue("invoice_template_settings.contact_info.email", !field.value)}
                                    />
                                </label>
                            )}
                        </Field>
                        <Field name="invoice_template_settings.contact_info.office_number">
                            {({ field, form }) => (
                                <label className="switch w-1/2 justify-between">
                                    <span className="switch-label">Show Contact Office Number</span>
                                    <input
                                        type="checkbox"
                                        checked={field.value}
                                        onChange={() => setFieldValue("invoice_template_settings.contact_info.office_number", !field.value)}
                                    />
                                </label>
                            )}
                        </Field>
                        <Field name="invoice_template_settings.contact_info.home_number">
                            {({ field, form }) => (
                                <label className="switch w-1/2 justify-between">
                                    <span className="switch-label">Show Contact Home Number</span>
                                    <input
                                        type="checkbox"
                                        checked={field.value}
                                        onChange={() => setFieldValue("invoice_template_settings.contact_info.home_number", !field.value)}
                                    />
                                </label>
                            )}
                        </Field>
                        <Field name="invoice_template_settings.contact_info.fax_number">
                            {({ field, form }) => (
                                <label className="switch w-1/2 justify-between">
                                    <span className="switch-label">Show Contact Fax Number</span>
                                    <input
                                        type="checkbox"
                                        checked={field.value}
                                        onChange={() => setFieldValue("invoice_template_settings.contact_info.fax_number", !field.value)}
                                    />
                                </label>
                            )}
                        </Field>
                        <Field name="invoice_template_settings.contact_info.mobile_number">
                            {({ field, form }) => (
                                <label className="switch w-1/2 justify-between">
                                    <span className="switch-label">Show Contact Mobile Number</span>
                                    <input
                                        type="checkbox"
                                        checked={field.value}
                                        onChange={() => setFieldValue("invoice_template_settings.contact_info.mobile_number", !field.value)}
                                    />
                                </label>
                            )}
                        </Field>
                        <Field name="invoice_template_settings.contact_info.business_name">
                            {({ field, form }) => (
                                <label className="switch w-1/2 justify-between">
                                    <span className="switch-label">Show Contact Business Name</span>
                                    <input
                                        type="checkbox"
                                        checked={field.value}
                                        onChange={() => setFieldValue("invoice_template_settings.contact_info.business_name", !field.value)}
                                    />
                                </label>
                            )}
                        </Field>
                    </div>
                    {/* <div className="space-y-5 mt-8">
                    <div className='flex items-center'>
                        <span className='w-12 h-0.5 bg-border inline-block mr-2'></span>
                        <p className='text-sm'>Matter Information</p>
                    </div>
                    <div className='w-1/2'>
                        <label className="form-label mb-1">Matter Label</label>
                        <Field className="input" type="text" name={`invoice_template_settings.matter_info.label`} />
                    </div>
                    <Field name="invoice_template_settings.matter_info.show_matter_name">
                        {({ field, form }) => (
                            <label className="switch w-fit">
                            <span className="switch-label">Show Matter Name</span>
                            <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() => setFieldValue("invoice_template_settings.matter_info.show_matter_name", !field.value)}
                            />
                            </label>
                        )}
                    </Field>
                </div> */}
                </div>
                <div className='lg:w-1/2 w-full'>
                    <div className="space-y-5 md:mt-0 mt-8">
                        <div className='flex items-center'>
                            <span className='w-12 h-0.5 bg-border inline-block mr-2'></span>
                            <p className='text-sm'>Company Information</p>
                        </div>
                        {/* <Field name="invoice_template_settings.company_info.company_logo">
                        {({ field, form }) => (
                            <label className="switch w-1/2 justify-between">
                            <span className="switch-label">Show Company Logo</span>
                            <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() => setFieldValue("invoice_template_settings.company_info.company_logo", !field.value)}
                            />
                            </label>
                        )}
                    </Field> */}
                        <Field name="invoice_template_settings.company_info.website">
                            {({ field, form }) => (
                                <label className="switch w-1/2 justify-between">
                                    <span className="switch-label">Show Company Website</span>
                                    <input
                                        type="checkbox"
                                        checked={field.value}
                                        onChange={() => setFieldValue("invoice_template_settings.company_info.website", !field.value)}
                                    />
                                </label>
                            )}
                        </Field>
                        <Field name="invoice_template_settings.company_info.address">
                            {({ field, form }) => (
                                <label className="switch w-1/2 justify-between">
                                    <span className="switch-label">Show Company Address</span>
                                    <input
                                        type="checkbox"
                                        checked={field.value}
                                        onChange={() => setFieldValue("invoice_template_settings.company_info.address", !field.value)}
                                    />
                                </label>
                            )}
                        </Field>
                        <Field name="invoice_template_settings.company_info.city">
                            {({ field, form }) => (
                                <label className="switch w-1/2 justify-between">
                                    <span className="switch-label">Show Company City</span>
                                    <input
                                        type="checkbox"
                                        checked={field.value}
                                        onChange={() => setFieldValue("invoice_template_settings.company_info.city", !field.value)}
                                    />
                                </label>
                            )}
                        </Field>
                        <Field name="invoice_template_settings.company_info.state">
                            {({ field, form }) => (
                                <label className="switch w-1/2 justify-between">
                                    <span className="switch-label">Show Company State</span>
                                    <input
                                        type="checkbox"
                                        checked={field.value}
                                        onChange={() => setFieldValue("invoice_template_settings.company_info.state", !field.value)}
                                    />
                                </label>
                            )}
                        </Field>
                        <Field name="invoice_template_settings.company_info.country">
                            {({ field, form }) => (
                                <label className="switch w-1/2 justify-between">
                                    <span className="switch-label">Show Company Country</span>
                                    <input
                                        type="checkbox"
                                        checked={field.value}
                                        onChange={() => setFieldValue("invoice_template_settings.company_info.country", !field.value)}
                                    />
                                </label>
                            )}
                        </Field>
                        <Field name="invoice_template_settings.company_info.zip_postal_code">
                            {({ field, form }) => (
                                <label className="switch w-1/2 justify-between">
                                    <span className="switch-label">Show Company Zip/Postal Code</span>
                                    <input
                                        type="checkbox"
                                        checked={field.value}
                                        onChange={() => setFieldValue("invoice_template_settings.company_info.zip_postal_code", !field.value)}
                                    />
                                </label>
                            )}
                        </Field>
                        <Field name="invoice_template_settings.company_info.firm_email">
                            {({ field, form }) => (
                                <label className="switch w-1/2 justify-between">
                                    <span className="switch-label">Show Company/Firm Email</span>
                                    <input
                                        type="checkbox"
                                        checked={field.value}
                                        onChange={() => setFieldValue("invoice_template_settings.company_info.firm_email", !field.value)}
                                    />
                                </label>
                            )}
                        </Field>
                        <Field name="invoice_template_settings.company_info.phone_number">
                            {({ field, form }) => (
                                <label className="switch w-1/2 justify-between">
                                    <span className="switch-label">Show Company Phone Number</span>
                                    <input
                                        type="checkbox"
                                        checked={field.value}
                                        onChange={() => setFieldValue("invoice_template_settings.company_info.phone_number", !field.value)}
                                    />
                                </label>
                            )}
                        </Field>
                        <Field name="invoice_template_settings.company_info.legal_business_name">
                            {({ field, form }) => (
                                <label className="switch w-1/2 justify-between">
                                    <span className="switch-label">Show Company Name</span>
                                    <input
                                        type="checkbox"
                                        checked={field.value}
                                        onChange={() => setFieldValue("invoice_template_settings.company_info.legal_business_name", !field.value)}
                                    />
                                </label>
                            )}
                        </Field>
                    </div>
                </div>
            </div>
        </>
    )
}

export { ContactMatter }